import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/service/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  public accessRoles:any={};
  public loginClientDetails:any = {};
  public switchUserAccess:boolean = false;
  constructor(private apiRequest: ApiRequestService) { 
    this.accessRoles = JSON.parse(localStorage.getItem('access') || '');
    this.accessRoles = this.accessRoles.access_rules;
    this.checkSwitchUserAccess();
    this.setClientDetails();
  }

  checkSwitchUserAccess(){
    if(this.accessRoles && this.accessRoles.header && this.accessRoles.header.switch_user){
      this.switchUserAccess = true;
    }
     

  }

  setClientDetails(){
    if(localStorage.getItem('clientDetails'))
    {
      this.loginClientDetails = localStorage.getItem('clientDetails');
      this.loginClientDetails = JSON.parse(this.loginClientDetails);
    }
  }

  onDownloadOverallReport(query:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    opt['query'] = query
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('GET','/reports/overall_report',{},opt);
    // return this.apiRequest.request('GET','/reports/complete_report_download',{},opt);
  }

  getReasonList(){
    let opt = {};
    return this.apiRequest.request('GET','/overall-reason-list',{},opt);
  }

  getOverallReport(query:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if (query && Object.keys(query).length) {
      opt['query'] = query.filter
    }
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length && !opt.query['clientUUIDs'])
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    } 
    return this.apiRequest.request('GET','/reports/overall_report',{},opt);
    // return this.apiRequest.request('GET','/reports/complete_report',{},opt);
  }

  getSurveyList(status?:string){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    let url = '/reports/surveys/'
    if (status && status != "") {
      url += status
    }
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    } 
    console.log("url is,", url)
    return this.apiRequest.request('GET',url,{},opt);
  }
}
